import { useProfiles } from "./use-profiles"

export function useProfile(id: string | null | undefined) {
  return useProfiles({
    select: (result) => result.profiles.find((profile) => profile.id === id),
  })
}
